import React, { PureComponent } from 'react';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_REST } from '../../../../constants/connectionCategories';
import isNil from 'lodash/isNil';

class APISinkConfiguration extends PureComponent {
  render() {
    const { config, ...otherProps } = this.props;
    const { 'body.template': bodyTemplate, ...otherConfig } = !isNil(config) ? config : {};

    return (
      <ConfigurationFields
        {...otherProps}
        config={otherConfig}
        connectionCategory={CONNECTION_CATEGORY_REST}
      />
    );
  }
}

export default APISinkConfiguration;
